import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import InputField from '../component/InputField'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import SelectDropDown from '../component/SelectDropDown'
import RegistrationService from '../services/registration'
import OtherService from '../services/Other'
import { useNavigate, useParams } from 'react-router-dom'
import AlertMsg from '../component/AlertMsg'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import useScrollToTop from '../hooks/useScrollToTop'
const EditAddress = () => {
    useScrollToTop()
    const { addressId } = useParams();
    const tokens =  useSelector(
        state => state.userTypeSlice.token,
      );

    const navigate = useNavigate()
    const [isAddress, setIsAddress] = useState({
        line1: '',
        line2: '',
        line3: '',
        post_code: '',
        otp: ""
    })
    const [loading, setLoading] = useState(true);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [hasAddress, setHasAddress] = useState(true)
    const [isPincode, setIsPincode] = useState('')
    //Country
    const [isCountryList, setIsCountryList] = useState([])
    const [contentCountry, setContentCountry] = useState({ id: '', title: '' });
    //State
    const [isStateList, setIsStateList] = useState([])
    const [contentState, setContentState] = useState({ id: '', title: '' });
    //City
    const [isCityList, setIsCityList] = useState([])
    const [contentCity, setContentCity] = useState({ id: '', title: '' });
    //District
    const [isDistrictList, setIsDistrictList] = useState([])
    const [contentDistrict, setContentDistrict] = useState({ id: '', title: '' });
    const [otpStatus, setOtpStatus] = useState(false);
    const [pincodeData, setPincodeData] = useState(null);
    
    const getPincodeDetails = async (pincode) => {
        try {
            const response = await OtherService.getPincodeDetails(pincode);
            const data = response?.data?.data;
            console.log("DATA=============",data);
            if (response?.data?.status === true && data && Object.keys(data).length > 0) {
                setPincodeData(data);
            } else {
                setPincodeData(null);
            }
        } catch (error) {
            console.error('Pincode API error:', error);
            setPincodeData(null);
        }
    };

    useEffect(() => {
        const AddressFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const AddressFetchResponse = await OtherService.addressListById(addressId)
                if (JSON.stringify(AddressFetchResponse) != '{}' && AddressFetchResponse.data.status === true && JSON.stringify(AddressFetchResponse.data.addressDetails) != '{}') {
                    setIsAddress(AddressFetchResponse.data.addressDetails)
                    setHasAddress(true)
                    setContentCountry({
                        id: AddressFetchResponse.data.addressDetails.dcm_countries_id,
                        title: AddressFetchResponse.data.addressDetails.country_name
                    })
                    setContentState({
                        id: AddressFetchResponse.data.addressDetails.dcm_states_id,
                        title: AddressFetchResponse.data.addressDetails.state_name
                    })
                    setTimeout(() => {
                        setContentCity({
                            id: AddressFetchResponse.data.addressDetails.dcm_cities_id,
                            title: AddressFetchResponse.data.addressDetails.city
                        })
                    }, 200)

                    setTimeout(() => {
                        setContentDistrict({
                            id: AddressFetchResponse.data.addressDetails.dcm_districts_id,
                            title: AddressFetchResponse.data.addressDetails.district_name
                        })
                    }, 300)
                    // setTimeout(() => {
                    //     setContentDistrict({
                    //         id: AddressFetchResponse.data.addressDetails.dcm_districts_id,
                    //         title: AddressFetchResponse.data.addressDetails.district_name
                    //     })
                    // }, 400)
                    
                    
                    setLoading(false)
                }
                else {
                    setIsAddress(AddressFetchResponse.data.message)
                    setHasAddress(false)
                }
            }
            catch (error) {
                console.error("Address Fetch")
            }

        }
        AddressFetchData()

    }, [])
    //All Countries
    useEffect(() => {
        const fetchCountryData = async () => {
            try {
                const response = await RegistrationService.allCountries();
                const countryNames = response.response.countriesDetails.filter(item =>
                    ['India'].includes(item.name),
                ).map(country =>
                (
                    {
                        id: country.id,
                        title: country.name
                    }
                )
                );
                setIsCountryList(countryNames[0])

            }
            catch (error) {
                console.error('Error fetching country data:');
            }
        };
        fetchCountryData()
    }, [])
    //All States
    useEffect(() => {
        const stateListFetch = async () => {

            if (contentCountry.id) {
                try {
                    if (pincodeData?.state_id) {
                        setContentState({ id: pincodeData.state_id, title: pincodeData.state_name });
                    }
                    const stateListResponse = await RegistrationService.allStates(contentCountry.id);
                    if (stateListResponse.success == true) {
                        if (stateListResponse.response.statesDetails.length > 0) {
                            const statesDetails = stateListResponse.response.statesDetails;

                            setIsStateList(statesDetails.map((item) => ({
                                id: item.id,
                                title: item.name
                            })));
                        }
                    }

                } catch (error) {
                    console.error("Error");
                }
            };
        };

        stateListFetch();
    }, [contentCountry.id, pincodeData]);
    //All City
    useEffect(() => {

        const fetchCityList = async () => {

            if (contentCountry.id && contentState.id) {
                try {
                    const cityListResponse = await RegistrationService.allCities(contentCountry.id, contentState.id);
                    setIsCityList(cityListResponse.response.citiesDetails.map((item) =>
                    (
                        {
                            id: item.id,
                            title: item.name
                        }
                    )
                    ))

                }
                catch (error) {
                    console.error("Error")

                }
            }
        }
        fetchCityList()
    }, [contentCountry.id, contentState.id])

    useEffect(() => {
        const fetchDistrictList = async () => {
            const token = localStorage.getItem("access_token");
    
            setContentDistrict({ id: '', title: '' });
            setIsDistrictList([]);
    
            if (contentCountry.id && contentState.id) {
                try {
                    if (pincodeData?.district_id) {
                        setContentDistrict({ id: pincodeData.district_id, title: pincodeData.district_name });
                    }
                    const districtListResponse = await RegistrationService.allDistricts(contentCountry.id, contentState.id, token);
                    if (districtListResponse.success === true) {
                        if (districtListResponse.response.districtDetails.length > 0) {
                            setIsDistrictList(districtListResponse.response.districtDetails.map((item) => ({
                                id: item.id,
                                title: item.name
                            })));
                        }
                    }
                } catch (error) {
                    console.error("Error");
                }
            }
        };
    
        fetchDistrictList();
    }, [contentCountry.id, contentState.id, pincodeData]);
    

    const handleNameInput = (e) => {
        const { name, value } = e.target;
        if (name === 'post_code') {
            const regex = /^[0-9]*$/;
            if (!regex.test(value)) {
                setIsPincode('Pincode must be numeric');
                return;
            }
            else{
                setIsPincode('');
                setPincodeData(null);
                setContentState({ id: '', title: '' });
                setContentDistrict({ id: '', title: '' });
                if (value.length === 6) {
                    getPincodeDetails(value);
                }
            }
        }
        setIsAddress({
            ...isAddress,
            [name]: value
        });

    }
    const handleContentCountryNameChange = (selectedValue) => {
        setContentCountry(selectedValue);
    }
    const handleContentStateNameChange = (selectedValue) => {
        setContentState(selectedValue)
        setContentDistrict({ id: "", title: "" })
    }
    const handleContentCityNameChange = (selectedValue) => {
        setContentCity(selectedValue)
    }
    const handleContentDistrictNameChange = (selectedValue) => {
        setContentDistrict(selectedValue)
    }

    const handleAddressEdit = async () => {
        const token = localStorage.getItem('access_token');
    
        if (!addressId || !isAddress.line1 || !isAddress.line3 ||
            !contentState.id || !contentDistrict.id || !contentCountry.id ||
            !isAddress.post_code || !isAddress.line2) {
            toast.error("Please fill all the required details edit");
            return;
        }

        const payload = {
            recipient: '',
            address_id: parseInt(addressId),
            address: isAddress.line1,
            landmark: isAddress.line3,
            city: contentDistrict.title,
            state: parseInt(contentState.id),
            district: parseInt(contentDistrict.id),
            country: parseInt(contentCountry.id),
            taluka: null,
            pin_code: isAddress.post_code,
            post_office: isAddress.line2,
            otp: isAddress.otp
        };
    
        setIsButtonLoading(true);
    
        try {            
            const EditAddressSubmit = await OtherService.editAddress(payload);
            setIsButtonLoading(false);
    
            if (EditAddressSubmit.response_code === 200) {
                toast.success("Address has been edited successfully");
                setTimeout(() => {
                    navigate('/address-list');
                }, 4000);
            } else {
                const errorMessage = EditAddressSubmit?.errorMessage?.reason?.message || "Something went wrong";
                toast.error(errorMessage);
            }
        } catch (error) {
            setIsButtonLoading(false);
            console.error("Edit Address Error:");
    
            const errorMessage = error?.response?.data?.errorMessage?.reason?.message || "Invalid OTP";
            toast.error(errorMessage);
        }
    };
    useEffect(() => {
        if(isAddress.otp?.length === 6){handleAddressEdit()}
    }, [isAddress.otp]);
    

    function sendOtp() {
        if(!addressId || !isAddress.line1 || !isAddress.line3 || !contentState.id || !contentDistrict.id || !contentCountry.id || !isAddress.post_code || !isAddress.line2) {
            toast.error("Please fill all the required details");
            return;
       }
    //    if(!isAddress.otp) {
    //         toast.error("Please enter OTP");
    //         return;
    //    }
        const payloadOtp = { address_id: parseInt(addressId) };
        setIsButtonLoading(true);
        RegistrationService.addressOtp(payloadOtp).then(res => {
          setIsButtonLoading(false);
          if (!res.error) {
            if (res.response.status == 'true') {
              setOtpStatus(true);
              toast.success("Otp has been send !")
            } else {
                toast.error("Cannot send otp right now !")
            }
          } else {
            toast.error('Something went wrong !');
          }
        }).catch(() => {
            setIsButtonLoading(false);
        });
      }

    return (
        <>
            <BreadCrumbSecttion pageTitle="Edit Address" currentPageName="Edit Address" />
            <section className='padTop50'>
                {hasAddress ? (
                    <Container>
                        <Row className='justify-content-center align-item-center h-100'>
                            <Col xs={12} >
                                <div className='userInfoBox'>
                                    <div className='dashboard-title'>
                                        <h4>Please Edit The Address</h4>
                                    </div>
                                    <div className="dashboard-details">
                                        <Row>

                                            <Col xs={12} lg={3}>
                                                <InputField
                                                    inputFieldLabel="Flat,House,Building No"
                                                    requiredStar="*"
                                                    name="line1"
                                                    value={isAddress?.line1}
                                                    onChange={handleNameInput}
                                                />

                                            </Col>
                                            <Col xs={12} lg={3}>
                                                <InputField
                                                    inputFieldLabel="Area, Street"
                                                    requiredStar="*"
                                                    name="line2"
                                                    value={isAddress?.line2}
                                                    onChange={handleNameInput}
                                                />

                                            </Col>
                                            {/* <Col xs={12} lg={3}>
                                            <SelectDropDown labelName="Country"
                                                requiredStar="*"
                                                options={isCountryList}
                                                setSelectedValue={setContentCountry}
                                                selectedValue={contentCountry}
                                                onChange={handleContentCountryNameChange}
                                                page='searchFilter'
                                            />

                                        </Col> */}

                                            <Col xs={12} lg={3}>
                                                <InputField
                                                    inputFieldLabel="Pincode"
                                                    requiredStar="*"
                                                    name="post_code"
                                                    value={isAddress?.post_code}
                                                    onChange={handleNameInput}
                                                />
                                                {isPincode && (
                                                <div className="error-message">{isPincode}</div>
                                            )}
                                            </Col>

                                            <Col xs={12} lg={3}>
                                                <SelectDropDown labelName="State"
                                                    requiredStar="*"
                                                    options={isStateList}
                                                    setSelectedValue={setContentState}
                                                    selectedValue={contentState}
                                                    onChange={handleContentStateNameChange}
                                                    page='searchFilter' 
                                                    disabled={pincodeData?.state_name}
                                                    />

                                            </Col>
                                            {/* <Col xs={12} lg={3}>
                                            <SelectDropDown labelName="City"
                                                requiredStar="*"
                                                options={isCityList}
                                                setSelectedValue={setContentCity}
                                                selectedValue={contentCity}
                                                onChange={handleContentCityNameChange}
                                                page='searchFilter' />

                                        </Col> */}
                                            <Col xs={12} lg={3}>
                                                <SelectDropDown labelName="District"
                                                    requiredStar="*"
                                                    options={isDistrictList || pincodeData?.district_name}
                                                    setSelectedValue={setContentDistrict}
                                                    selectedValue={contentDistrict}
                                                    onChange={handleContentDistrictNameChange}
                                                    page='searchFilter' 
                                                    disabled={pincodeData?.district_name}
                                                    />

                                            </Col>
                                            
                                            <Col xs={12} lg={3}>
                                                <InputField
                                                    inputFieldLabel="Landmark"
                                                    requiredStar="*"
                                                    name="line3"
                                                    value={isAddress?.line3}
                                                    onChange={handleNameInput}
                                                />

                                            </Col>
                                            {otpStatus && <Col xs={12} lg={3}>
                                                <InputField
                                                    inputFieldLabel="OTP"
                                                    requiredStar="*"
                                                    name="otp"
                                                    value={isAddress?.otp}
                                                    onChange={handleNameInput}
                                                />

                                            </Col>}
                                            {otpStatus && <Col xs={12} lg={3}>
                                                <PrimaryGradientButton
                                                    buttonText={isButtonLoading ? "Processing..." : "Submit"}
                                                    className="mt-28"
                                                    // onClick={handleAddressEdit}
                                                    disabled={isButtonLoading}
                                                    />

                                            </Col>}
                                            {!otpStatus && <Col xs={12} lg={3}>
                                                <PrimaryGradientButton
                                                    buttonText={isButtonLoading ? "Processing..." : "Send OTP"}
                                                    className="mt-28"
                                                    onClick={sendOtp}
                                                    disabled={isButtonLoading} />

                                            </Col>}
                                            <Col xs={12} lg={3}></Col>
                                            <Col xs={12} lg={3} className='mt-3'>

                                                {/* {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                                    heading={isLoginSuccess.heading}
                                                    text={isLoginSuccess.text}
                                                />
                                                } */}
                                            </Col>

                                        </Row>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                ) : (
                    // Render the value of isAddress if it is falsy
                    <div>{isAddress}</div>
                )}

            </section>
        </>
    )
}

export default EditAddress